<template>
  <PopoverMenu placement="top" size="fit-content" v-model:open="open">
    <template #trigger>
      <button class="color-palette-button" data-test-id="color-palette-button">
        <span class="color-palette-button__background" />
      </button>
    </template>
    <template #popover>
      <ColorSelector :modelValue="modelValue" @setColor="onSetColor" @close="onClose" />
    </template>
  </PopoverMenu>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import ColorSelector from './ColorSelector.vue';

export default defineComponent({
  name: 'ColorPaletteButton',
  components: { ColorSelector },
  emits: { change: null },

  props: {
    modelValue: {
      type: String,
      default: '#ff0000',
    },
  },

  data() {
    return {
      open: false,
    };
  },

  methods: {
    onSetColor(newValue: string): void {
      this.open = false;
      this.$emit('change', newValue);
    },
    onClose(): void {
      this.open = false;
    },
  },
});
</script>

<style lang="scss">
@use 'settings/colors';
@use 'settings/settings';
.color-palette-button {
  position: relative;
  height: 40px;
  width: 40px;
  background: transparent;
  border-radius: settings.$border-radius;
  cursor: pointer;
  box-shadow: settings.$box-shadow-border-grey-50-hidden;

  &.active,
  &:focus,
  &:hover {
    box-shadow: settings.$box-shadow-border-grey-50;
  }
}

.color-palette-button__background {
  position: absolute;
  top: 8px;
  left: 8px;
  height: 24px;
  width: 24px;
  border-radius: 50%;
  background: conic-gradient(from 180deg, red, orange, yellow, green, blue);
  pointer-events: none;
}
</style>
